const WORDS_PER_MINUTE = 250;
const HTML_REGEX = /<[^>]+>/g;

export const getReadTime = (body: string) => {
  const bodyLength = body?.replace(HTML_REGEX, '').split(' ').length;
  return `'${Math.ceil(bodyLength / WORDS_PER_MINUTE)} min`;
};
